import classNames from 'classnames';
import { useId } from 'react';
import {
  Button as ReactAriaButton,
  Disclosure as ReactAriaDisclosure,
  DisclosurePanel as ReactAriaDisclosurePanel,
} from 'react-aria-components/Disclosure';

import Icon from '../../../../../app/shared/components/Icon/Icon';
import css from './ExpandableSection.css';

interface ExpandableSectionProps {
  heading: string;
  children: (triggerId: string) => React.ReactNode;
  className?: string;
  onExpandedChange?: (isExpanded: boolean) => void;
}

const ExpandableSection = ({ children, className, heading, onExpandedChange }: ExpandableSectionProps) => {
  const triggerId = useId();

  return (
    <ReactAriaDisclosure className={classNames(css.root, className)} onExpandedChange={onExpandedChange}>
      <h3>
        <ReactAriaButton id={triggerId} slot="trigger" className={css.trigger}>
          {heading}
          <Icon className={css.icon} name="angleDown" />
        </ReactAriaButton>
      </h3>
      <ReactAriaDisclosurePanel>{children(triggerId)}</ReactAriaDisclosurePanel>
    </ReactAriaDisclosure>
  );
};

export default ExpandableSection;
